import { buildingsSchema } from '@/entities/knowledge/model/types';
import { z } from 'zod';

const linkTextSchema = z.object({
  label: z.string(),
  href: z.string(),
});

const legalSchema = z.object({
  linksText: z.array(linkTextSchema),
  disclaimer: z.string(),
  consentNotice: z.string(),
});

const footerSchema = z.object({
  legal: legalSchema,
});

const contactsSchema = z.object({
  phoneNumbers: z.array(z.string()),
  telegramUrl: z.string(),
  whatsappUrl: z.string(),
  address: z.string(),
  email: z.string(),
});

export type contactsType = z.infer<typeof contactsSchema>;

const propertySchema = z.object({
  id: z.string(),
  title: z.string(),
  minArea: z.number(),
  areaUnit: z.string(),
  minPrice: z.number(),
  currency: z.string(),
  imageUrl: z.string().nullable(),
});

export type propertyType = z.infer<typeof propertySchema>;

const statSchema = z.object({
  value: z.number(),
  label: z.string(),
});

const linkButtonSchema = z.object({
  text: z.string(),
  link: z.string(),
});

const ctaSchema = z.object({
  text: z.string(),
  linkButton: linkButtonSchema,
});

const commercialSectionSchema = z.object({
  title: z.string(),
  description: z.string(),
  cta: ctaSchema,
  stats: z.record(z.string(), statSchema),
  properties: z.array(propertySchema),
});

const directionSchema = z.object({
  id: z.enum(['commercial', 'retail', 'residential']),
  title: z.string(),
  description: z.string(),
  imageUrl: z.string().nullable(),
});

export type directionType = z.infer<typeof directionSchema>;

const companySchema = z.object({
  name: z.string(),
  directions: z.array(directionSchema).max(3),
});

const homePageSchema = z.object({
  company: companySchema,
  commercialSection: commercialSectionSchema,
});

export const rootSchema = z.object({
  id: z.string().optional(),
  homePage: homePageSchema,
  contacts: contactsSchema,
  footer: footerSchema,
  buildings: buildingsSchema,
});

export type contentType = z.infer<typeof rootSchema>;

// Пример использования:
// const result = rootSchema.safeParse(yourData);
// if (!result.success) {
//   console.error(result.error);
// } else {
//   console.log("Valid data", result.data);
// }
